module.exports = __webpack_public_path__ + "img/patent_image11.0ad22e96.png";